/**
 * 读取宿主商城登录态 —— widget 嵌在第三方商城页面（同源直接注入 DOM），
 * 商城把会员登录态写在 localStorage 键 `mall:auth`（JSON）：
 *   { "token": "<JWT>", "member": { "id": "...", "phone": "..." }, "savedAt": "..." }
 *
 * 这里只取其中的 `token`，随访客消息回传 BE，供后端调主站 C 端订单/工单 API。
 * token 是敏感凭证：仅本轮透传，BE 不落库、不进 prompt。
 *
 * 容错：未登录 / 隐私模式 / 键不存在 / JSON 损坏 一律降级为 null（不抛）。
 */

const MALL_AUTH_KEY = 'mall:auth';

/** 读宿主商城登录 token；取不到返回 null。每次调用即时读，确保拿到最新（token 会过期/换号）。 */
export function readHostToken(): string | null {
  try {
    const raw = localStorage.getItem(MALL_AUTH_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { token?: unknown };
    const token = parsed?.token;
    return typeof token === 'string' && token.trim() ? token : null;
  } catch {
    // localStorage 不可用（隐私模式 / 跨域隔离）或 JSON 非法
    return null;
  }
}
